import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as React from 'react';
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../assets/swiperCss.css";
import 'swiper/css/autoplay';

import AdminMenuComponent from "../../components/admin/AdminMenuComponent.js";

const widthPageSlide = 600;

const GiftcardsPageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();
  const config = require("../../constants/constants.js")

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget.elements;

    const email = form.email.value;
    const password = form.password.value;
    const doNotLogout = form.doNotLogout.checked;

    if (event.currentTarget.checkValidity() === true && email && password) {
      setLoginUserResponseState({ loading: true });
      loginUserApiRequest(email, password, doNotLogout)
        .then((res) => {
          setLoginUserResponseState({ success: res.success, loading: false, error: "" });

          if (res.userLoggedIn) {
            reduxDispatch(setReduxUserState(res.userLoggedIn));
          }

          if (res.success === "user logged in" && !res.userLoggedIn.isAdmin) window.location.assign('/user')
          else window.location.assign('/admin/categories')

        })
        .catch((er) =>
          setLoginUserResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data })
        );
    }

    setValidated(true);
  };

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage1, setPathImage1] = useState("");
  const [pathImage2, setPathImage2] = useState("");
  const [pathImage3, setPathImage3] = useState("");
  const [titleImage1, setTitleImage1] = useState("");
  const [subTitleImage1, setSubTitleImage1] = useState("");
  const [titleImage2, setTitleImage2] = useState("");
  const [subTitleImage2, setSubTitleImage2] = useState("");
  const [titleImage3, setTitleImage3] = useState("");
  const [subTitleImage3, setSubTitleImage3] = useState("");

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    console.log(`data =`, data);
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('GIFTCARDS').then((data) => {
      console.log(`data 1 =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setPathImage1(data?.images[0].path);
      setPathImage2(data?.images[1].path);
      setPathImage3(data?.images[2].path);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setTitleImage1(data?.imagesTitle[0].text);
      setSubTitleImage1(data?.imagesSubTitle[0].text);
      setTitleImage2(data?.imagesTitle[1].text);
      setSubTitleImage2(data?.imagesSubTitle[1].text);
      setTitleImage3(data?.imagesTitle[2].text);
      setSubTitleImage3(data?.imagesSubTitle[2].text);
      console.log(`id =`, id);
      console.log(`page?.title.text =`, page?.title.text);
      console.log(`page?.description.text =`, page?.description.text);
      console.log(`page?.customizedContent =`, page?.customizedContent);
      console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])

  return (

    <Box sx={{ flexGrow: 1 }}>

      <AdminMenuComponent></AdminMenuComponent>

      <Breadcrumbs separator="›" aria-label="breadcrumb"
        size={{ xs: 12, md: 4 }}
        paddingTop={{ xs: 3, md: 3 }}
        paddingLeft={{ xs: 2, md: 6 }}
        paddingRight={{ xs: 1, md: 8 }}
        spacing={{ xs: 2, md: 2 }}
      >
        <Link underline="hover" color="inherit" href="/">
          {config.BC_HOME}
        </Link>
        <Typography sx={{ color: 'text.primary' }}>{config.BC_GIFTCARDS}</Typography>
      </Breadcrumbs>

      <Grid container spacing={2}>

        <Grid
          size={{ xs: 0, md: 0 }}
        >
        </Grid>

        <Grid
          size={{ xs: 12, md: 5 }}
          padding={{ xs: 0, md: 4 }}
        >

          <Box sx={{ width: { md: { widthPageSlide } } }}>

            <Swiper
              style={{
                '--swiper-navigation-color': '#fff',
                '--swiper-pagination-color': '#fff',
              }}

              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false
              }}

              lazy={true}
              pagination={{
                clickable: true,
              }}
              navigation={true}
              modules={[Pagination, Navigation, Autoplay]}
              className="image-dim"
            >

              {page.images?.map((itemImg, id) => (

                <SwiperSlide>
                  <img
                    src={itemImg.path}
                    loading="lazy"
                  />
                  <div class="text-overlay">
                    <p>
                      <Typography variant="h6" color='#ffffff'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {itemImg.title}
                      </Typography>
                    </p>
                    <p>
                      <Typography variant="h7" color='#dfdfde'
                        sx={{
                          paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                          p: 0, m: 0,
                        }}
                      >
                        {itemImg.subTitle}
                      </Typography>
                    </p>
                  </div>
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                </SwiperSlide>

              ))}

              <SwiperSlide>
                <img
                  src={pathImage2}
                  loading="lazy"
                />
                <div class="text-overlay">
                  <p>
                    <Typography variant="h6" color='#ffffff'
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1,
                        p: 0, m: 0,
                      }}
                    >
                      {titleImage2}
                    </Typography>
                  </p>
                  <p>
                    <Typography variant="h7" color='#dfdfde'
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
                        p: 0, m: 0,
                      }}
                    >
                      {subTitleImage2}
                    </Typography>
                  </p>
                </div>
                <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
              </SwiperSlide>

            </Swiper>

          </Box>

        </Grid>

        <Grid
          size={{ xs: 12, md: 6 }}
          padding={{ xs: 1, md: 1 }}
          spacing={0}
        >

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 30
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 3, paddingLeft: 2, paddingRight: 2,
              background: '#cce0e6'

            }}
            elevation={6}
          >

            <Stack
              spacing={0}
              sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
            >

              <Typography
                sx={{
                  paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 500,
                  fontSize: 30,
                  color: 'navy',
                }}
              >
                <b>{title}</b>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 300,
                  fontSize: 20,
                  color: 'navy',
                }}
              >
                <em>{subTitle}</em>
              </Typography>

              <Typography
                sx={{
                  paddingTop: 2, paddingBottom: 0, paddingLeft: 4, paddingRight: 0,
                  fontFamily: 'Arial',
                  fontWeight: 100,
                  fontSize: 14,
                  color: 'black',
                }}
              >
                {description}
              </Typography>

            </Stack>

          </Paper>

        </Grid>

      </Grid>

      <Box
        sx={{
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          height: 30
        }}
      />

    </Box>

  );
};

export default GiftcardsPageComponent;
